// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'vue-use-vuex'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as Sentry from '@sentry/browser'
Vue.use(BootstrapVue)

Vue.config.productionTip = false

Sentry.init({
  dsn: 'https://2b6c6698faaf4eb8b878d227b46bde67@sentry.io/1336610',
  integrations: [new Sentry.Integrations.Vue({ Vue })]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js